import React from "react";
import { Dialog } from "primereact/dialog";
import { handlePrintData } from "../utils/PrintData";
import { CalculateAge } from "../utils/CalculateAge";
import { extractTextFromHTML } from "../utils/ExtractTextFromHtml";
import { formatDuration } from "../utils/FormateDuration";
import moment from "moment";

function UCAFdata({ item, edit }) {
  const getVitalValue = (category) => {
    const arr = item?.vital_signs || item?.vitalSigns;
    if (!arr || !Array.isArray(arr)) return "";
    const found = arr.find((v) => v?.category === category);
    return found ? found?.value || "" : "";
  };
  const headerOne = [
    { id: 1, name: "Code" },
    { id: 2, name: "Non-Standard Code" },
    { id: 3, name: "Description/Service" },
    { id: 4, name: "Type" },
    { id: 5, name: "Quantity" },
    { id: 6, name: "Approved Quantity" },
    { id: 7, name: "Cost" },
    { id: 8, name: "Approved Cost" },
    { id: 9, name: "Status" },
  ];
  console.log(item);

  const headerTwo = [
    { id: 1, name: "Medication Name (Generic Name)" },
    { id: 2, name: "Type" },
    { id: 3, name: "Quantity" },
  ];

  return (
    <div
      className="ucaf-form"
      style={{ fontSize: "12px", fontFamily: "Arial, sans-serif" }}
    >
      <style>
        {`
          @media print {
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            table {
              page-break-inside: auto;
            }
            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }
          }
        `}
      </style>

      <h3 className="text-xl text-center font-bold mb-2">UCAF 2.0</h3>

      {/* First Row - Two Columns */}
      <div className="grid grid-cols-2 gap-2 mb-2">
        {/* Left Column */}
        <div className="border border-black p-1 rounded">
          <h3 className="text-sm font-bold mb-1">
            To be completed &amp; ID verified by the reception/nurse:
          </h3>
          <div className="space-y-1">
            <div className="flex items-center">
              <span className="font-semibold mr-1">Provider Name:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.selected_plan?.payer_name || item?.patient?.insurance_plans?.[0]?.payer_name}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">
                Insurance Company Name:
              </span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.selected_plan?.payer_name || item?.patient?.insurance_plans?.[0]?.payer_name}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">TPA Company Name:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.selected_plan?.tpa_license_id || item?.patient?.insurance_plans?.[0]?.tpa_license_id}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">Patient MRN:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.file_no}
              </span>
            </div>
            <div className="flex items-center text-sm">
              <span className="font-semibold mr-1">Document ID:</span>
              <span className="border-b border-dotted border-black flex-1 font-semibold">
                {item?.patient?.document_id || "--"}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">Single () Married ():</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.selected_plan?.coverage_type || item?.patient?.insurance_plans?.[0]?.coverage_type}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">Date Of Visit:</span>
              <span className="border-b border-dotted border-black flex-1">
                {moment(item?.visit_date).format("DD-MM-YYYY")}
              </span>
            </div>
            <div className="flex space-x-2">
              <span>New Visit()</span>
              <span>FollowUp()</span>
              <span>Refill()</span>
              <span>WalkIn()</span>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center">
                <span className="font-semibold mr-1">Referrel:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item && item.is_referral ? "YES" : "NO"}
                </span>
              </div>
              <div className="flex items-center">
                <span className="font-semibold mr-1">Refer To:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.dischargeDisposition}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="border border-black p-1 rounded">
          <h3 className="text-sm font-bold mb-1">
            Print &amp; fill in clear letters or Emboss Card:
          </h3>
          <div className="space-y-1">
            <div className="flex items-center">
              <span className="font-semibold mr-1">Insured Name:</span>
              <span className="border-b border-dotted border-black flex-1 capitalize">
                {item?.patient?.full_name}
              </span>
            </div>
            <div className="flex items-center">
              <span className="font-semibold mr-1">ID Card Number:</span>
              <span className="border-b border-dotted border-black flex-1">
                {item?.patient?.selected_plan?.member_card_id ||
                  item?.patient?.insurance_plans?.[0]?.member_card_id}
              </span>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Sex:</span>
                <span className="border-b border-dotted border-black flex-1 capitalize">
                  {item?.patient?.gender}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Age:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {CalculateAge(item?.patient?.dob) || item?.patient?.dob}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Policy Holder:</span>
                <span className="border-b border-dotted border-black flex-1">
                  YES
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Policy Number:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.patient?.selected_plan?.policy_number || item?.patient?.insurance_plans?.[0]?.policy_number}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Date Of Expiry:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.patient?.selected_plan?.expiry_date ||
                    item?.patient?.insurance_plans?.[0]?.expiry_date}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Class:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.patient?.selected_plan?.class_name || item?.patient?.insurance_plans?.[0]?.class_name}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Approval:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.items?.find(
                    approvalItem => approvalItem?.approval_number
                  )?.approval_number ||
                    item?.approval_number ||
                    item?.pre_auth_ref_no}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Response Date:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {!(item?.status === "approved")
                    ? item?.response_date && item?.response_date?.length > 16
                      ? item?.response_date.substring(0, 16).replace("T", " ")
                      : item?.response_date
                    : null}
                </span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Approval Status:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.status}
                </span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-semibold mr-1">Approval Date:</span>
                <span className="border-b border-dotted border-black flex-1">
                  {item?.status === "approved"
                    ? item?.response_date && item?.response_date?.length > 16
                      ? item?.response_date.substring(0, 16).replace("T", " ")
                      : item?.response_date
                    : null}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Second Row - Physician Section */}
      <div className="border border-black p-1 rounded mb-2">
        <h3 className="text-sm font-bold mb-1">
          To be completed by Attending PHYSICIAN : Please tick (✔)
        </h3>

        <div className="flex justify-between items-center mb-1">
          <div className="flex space-x-2">
            <span>Inpatient ()</span>
            <span>Outpatient ()</span>
          </div>
          <div className="border border-black rounded flex items-center p-1 space-x-2">
            <span>EmergencyCase ()</span>
            <div className="flex items-center">
              <span className="font-semibold mr-1">EmergencyCareLavel:</span>
              <div className="flex space-x-1">
                <span>1 ( )</span>
                <span>2 ( )</span>
                <span>3 ( )</span>
                <span>4 ( )</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-between mb-1">
          <div className="flex items-center">
            <span className="font-semibold mr-1">BP /:</span>
            <span className="border-b border-dotted border-black w-8">
              {getVitalValue("vital-sign-systolic")}/{getVitalValue("vital-sign-diastolic")}
            </span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Pulse /:</span>
            <span className="border-b border-dotted border-black w-8">
              {getVitalValue("vital-sign-pulse")}
            </span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Temp /:</span>
            <span className="border-b border-dotted border-black w-8">
              {getVitalValue("vital-sign-temperature")}
            </span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Weight /:</span>
            <span className="border-b border-dotted border-black w-8">
              {getVitalValue("vital-sign-weight")}
            </span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Height /:</span>
            <span className="border-b border-dotted border-black w-8">{getVitalValue("vital-sign-height")}</span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">R.R /:</span>
            <span className="border-b border-dotted border-black w-8">{getVitalValue("vital-sign-respiratory-rate")}</span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Duration Of Illness /:</span>
            <span className="border-b border-dotted border-black w-8">{getVitalValue("duration-of-illness")}</span>
          </div>
        </div>

        <div className="mb-1">
          <div className="flex items-start">
            <span className="font-semibold mr-1">
              Chief Complaints and Main Symptoms:
            </span>

            <div className="border-b border-dotted border-black flex-1">
              {edit
                ? extractTextFromHTML(
                  item?.medical_assessments?.chief_complaints?.value
                )
                : extractTextFromHTML(item?.chiefComplaints?.value)}
            </div>
          </div>
        </div>
        <div className="space-y-1 mb-1">
          <div className="flex items-center">
            <span className="font-semibold mr-1">Significant Signs:</span>
            <span className="border-b border-dotted border-black flex-1">
              {edit
                ? extractTextFromHTML(
                  item?.medical_assessments?.significient_signs
                )
                : extractTextFromHTML(item?.significantSign)}
            </span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Other Conditions:</span>
            <span className="border-b border-dotted border-black flex-1">
              {edit
                ? extractTextFromHTML(
                  item?.medical_assessments?.other_conditions
                )
                : extractTextFromHTML(item?.otherCondition)}
            </span>
          </div>
          <div className="flex items-center">
            <span className="font-semibold mr-1">Diagnosis:</span>
            <span className="border-b border-dotted border-black flex-1">
              {edit
                ? item?.diagnosisArr
                  ?.map((diag) => {
                    return `${diag.codeId} - ${diag.codeDescription}`;
                  })
                  .join(", ")
                : item?.diagnosisArray
                  ?.map((diag) => {
                    return `${diag.codeId} - ${diag.codeDescription}`;
                  })
                  .join(", ")}
            </span>
          </div>
        </div>
        <div className="flex space-x-1 mb-2">
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">Principal Code:</span>
            <span className="border-b border-dotted border-black flex-1">
              {edit
                ? item?.diagnosisArr?.map((diag, ind) => {
                  return (
                    <span className="mx-3">{`${ind + 1} - ${diag.codeId
                      } `}</span>
                  );
                })
                : item?.diagnosisArray?.map((diag, ind) => {
                  return (
                    <span className="mx-3">{`${ind + 1} - ${diag.codeId
                      } `}</span>
                  );
                })}
            </span>
          </div>
          {/* <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">2nd Code:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">3rd Code:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">4th Code:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div> */}
        </div>

        <hr className="border-t border-black my-1" />

        <h3 className="text-sm font-bold mb-1">
          Please tick (✔) Where appropriate
        </h3>

        <div className="flex justify-between mb-1">
          <div className="flex space-x-5">
            <span>Chronic ( )</span>
            <span>Congenital ( )</span>
            <span>RTA ( )</span>
            <span>Work Related ( )</span>
            <span>Vaccination ( )</span>
            <span>Check-Up ( )</span>
            <span>Psychiatric ( )</span>
            <span>Infertility ( )</span>
            <span>Pregnancy ( )</span>
          </div>
          <div className="flex items-center">
            <span className="mr-1">Indicate LMP:</span>
            <span className="border-b border-dotted border-black w-16"></span>
          </div>
        </div>

        <p className="text-xs mb-1">
          Suggestive lines of Management: Kindly enumerate the recommended
          investigations, and/or procedures
          <b className="font-bold mx-1">For Outpatient approvals Only</b>
        </p>
        {/* First Table */}
        <div className="overflow-x-auto mb-2">
          <table className="w-full border border-black text-xs">
            <thead>
              <tr className="border border-black">
                {headerOne.map((item) => (
                  <th
                    key={item.id}
                    className="border border-black p-1 text-center"
                  >
                    {item.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {item?.items?.map((item, index) => (
                <tr key={index} className="border border-black">
                  <td className="border border-black p-1 text-center">
                    {item?.standard_code}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.non_standard_code}
                  </td>
                  <td className="border border-black p-1">
                    <div>{item?.standard_description}</div>
                    {item?.reject_reason_display && (
                      <div className="text-red-500 text-xxs mt-1">
                        <span className="font-semibold">Reject Reason: </span>
                        {item?.reject_reason_display}
                      </div>
                    )}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.selected_category}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.quantity}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.approved_quantity}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.unit_price}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.approved_value}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-xs mb-1">
          Providing approvals /Coding Staff must review /Code the recommended
          Service(s) and allocate code and complete the following:
        </p>

        <div className="flex space-x-1 mb-2">
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">Completed / Coded By:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">Signature:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-semibold mr-1">Date:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
        </div>

        {/* Second Table */}
        <div className="overflow-x-auto mb-2">
          <table className="w-full border border-black text-xs">
            <thead>
              <tr className="border border-black">
                {headerTwo.map((item) => (
                  <th
                    key={item.id}
                    className="border border-black p-1 text-center"
                  >
                    {item.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {item?.items?.map((item, index) => (
                <tr key={index} className="border border-black">
                  <td className="border border-black p-1">{`(${item?.standard_code}) - ${item?.standard_description}`}</td>
                  <td className="border border-black p-1 text-center">
                    {item?.selected_category}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.quantity}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex items-center space-x-2 mb-1">
          <span>In Case management form (CMF 1.0) included</span>
          <b>Yes ( ) No( )</b>
        </div>

        <div className="flex items-center mb-1">
          <span className="font-semibold mr-1">
            Please specify Possible line of management when applicable:
          </span>
          <span className="border-b border-dotted border-black flex-1"></span>
        </div>

        <div className="flex space-x-2 mb-1">
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Estimated length of Stay:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Estimated Date of admission:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
        </div>
      </div>

      {/* Third Row - Certifications */}
      <div className="border border-black p-1 rounded mb-2">
        <div className="grid grid-cols-2 gap-2">
          {/* Left Certification */}
          <div className="border-r border-gray-300 pr-2">
            <p className="text-xs mb-2">
              I hereby certify that ALL information mentioned are correct and
              that the medical services shown on this form were medically
              indicated and necessary for the management of this case.
            </p>
            <div className="flex justify-between">
              <div className="flex flex-col">
                <span className="font-bold">Physicians</span>
                <span className="border-b border-dotted border-black">
                  {edit
                    ? item?.careTeamsArr
                      ?.map((care) => care.practitionerName)
                      .join(", ")
                    : item?.careTeamsArray
                      .map((care) => care.practitionerName)
                      .join(", ")}
                </span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Signature</span>
                <span className="border-b border-dotted border-black"></span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Stamp</span>
                <input type="radio" className="mt-1" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Date</span>
                <span className="border-b border-dotted border-black"></span>
              </div>
            </div>
          </div>

          {/* Right Certification */}
          <div className="pl-2">
            <p className="text-xs mb-2">
              I hereby certify that ALL statements and information provided
              concerning patient identification and the present illness or
              injury are TRUE.
            </p>
            <div className="mb-1">
              <div className="flex items-center">
                <span className="font-bold mr-1">
                  Name (and relationship (if guardian)):
                </span>
                <span className="border-b border-dotted border-black flex-1"></span>
              </div>
            </div>
            <div className="flex space-x-2">
              <div className="flex items-center flex-1">
                <span className="font-bold mr-1">Signature:</span>
                <span className="border-b border-dotted border-black flex-1"></span>
              </div>
              <div className="flex items-center flex-1">
                <span className="font-bold mr-1">Date:</span>
                <span className="border-b border-dotted border-black flex-1"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Insurance Company Section */}
      <div className="border border-black p-1 rounded">
        <div className="mb-1">
          <div className="flex items-center">
            <span className="font-semibold mr-1">
              For Insurance Company Use Only:
            </span>
            <div className="flex space-x-20">
              <span>Approved ( )</span>
              <span>Not Approved ( )</span>
              <span>Approval No:</span>
              <span>Approval validity:</span>
            </div>
          </div>
        </div>

        <div className="mb-1">
          <span>
            Days Comments (include approved days/services if different from the
            requested):
          </span>
        </div>

        <hr className="border-t border-black my-1" />

        <div className="flex space-x-2">
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Approved/Disapproved By:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Signature:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
          <div className="flex items-center flex-1">
            <span className="font-bold mr-1">Date:</span>
            <span className="border-b border-dotted border-black flex-1"></span>
          </div>
        </div>
      </div>

      <p className="text-xs font-bold mt-1">
        (*) This is applicable only in case of manual UCAF
      </p>
    </div>
  );
}

function UcafForm({
  showUCAF = true,
  setShowUCAF = () => { },
  item = null,
  setSelectedData,
  edit = false,
}) {
  const handlePrint = async () => {
    const printContent = document.getElementById("print-content");
    if (!printContent) return;
    await handlePrintData(printContent.innerHTML);
  };
  return (
    <Dialog
      visible={showUCAF}
      onHide={() => {
        setShowUCAF(false);
        setSelectedData(null);
      }}
      style={{ width: "80vw", maxWidth: "1200px" }}
      header="UCAF Form"
      breakpoints={{ "960px": "75vw", "640px": "90vw" }}
      modal
    >
      <div id="print-content">
        <UCAFdata item={item} edit={edit} />
      </div>
      <div className="sticky bottom-0 bg-white p-4 pt-3 border-t">
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={() => {
              setShowUCAF(false);
              setSelectedData(null);
            }}
          >
            Close
          </button>
          <button
            type="button"
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={handlePrint}
          >
            Print
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default UcafForm;
